import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dot",
  "use": "icon-dot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dot\"><path d=\"M512 624a112 112 0 1 0 0-224 112 112 0 0 0 0 224z\" p-id=\"2252\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol